angular.module('leanlaw').controller('SummaryExpensesController', ['$scope', '$rootScope', '$q', '$window', '$filter', "$timeout", '$location', '$stateParams', '$state', "alerts", "userService", "leanLawApi", "reportsService", "exportJson", "singleRequest", function ($scope, $rootScope, $q, $window, $filter, $timeout, $location, $stateParams, $state, alerts, userService, leanLawApi, reportsService, exportJson, singleRequest) {
  $scope.activities = [{}];
  $scope.sort = 'date';
  $scope.reverse = false;

  // $scope.filter is owned by sidebar

  $scope.loading = true;

  //
  function load() {
    if ($scope.activeTab != "expenses") return;
    var query = queryFromFilter();
    if (!query) return;
    query.billed = 'any';
    query.billedState = undefined;
    $scope.loading = true;
    singleRequest.apiCall("tabdetail-expenses").listExpenses(query).then(list => {
      if (!list) return;
      $scope.expenses = list.expenses;
      $scope.total = list.expenses.reduce((sum, e) => sum + e.amount, 0);
      $scope.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    var query = reportsService.queryFromFilter($scope.filter);
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.export = function () {
    const exp = $scope.expenses.map(a => ({
      "Date": $filter("dateLogical")(a.date),
      "Description": a.description,
      "User": a.account ? a.account.name : "",
      "Matter": a.matter ? a.matter.label : '',
      "Amount": $filter("amount")(a.amount)
    }));
    exportJson.downloadCsv(exp);
  };
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    load();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    load();
  });

  // Suffix is the active tab name for this view
  $scope.$on("summary-export-expenses", payload => {
    $scope.export();
  });
  $scope.$watch("cm", newValue => {
    load();
  });
  $scope.$watch("activeTab", newValue => {
    $timeout(load);
  });
}]);